import React, { FC, ReactElement } from 'react';
import { graphql } from 'gatsby';
import { Link as ScrollLink } from 'react-scroll';

import IconCustom from 'common/IconCustom';
import { isEmptyArray } from 'utils/array';
import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import { textWithOutSpaces } from 'utils/stringUtils/stringUtils';

import './SecondaryNavigationWithLinks.scss';
import { IPropsSecondaryNavigationWithLinks } from './models';

const SecondaryNavigationWithLinks: FC<IPropsSecondaryNavigationWithLinks> = ({
  secondaryNavigationWithLinks,
}): ReactElement | null => {
  if (isEmptyArray(secondaryNavigationWithLinks)) return null;
  const {
    properties: { items },
  } = secondaryNavigationWithLinks[0];

  const settings = {
    duration: 500,
    spy: true,
    smooth: true,
    offset: -120,
  };

  return (
    <div className="secondary-navigation-with-links" data-test="SecondaryNavigation">
      <div className="secondary-navigation-with-links__wrapper">
        {items.map((item) => (
          <ScrollLink
            {...settings}
            to={item.properties.link[0].name}
            className="secondary-navigation-with-links__link"
            activeClass="active"
            href={`#${textWithOutSpaces(item.properties.link[0].name)}`}
          >
            <DangerouslySetInnerHtml
              html={item.properties.label}
              className="secondary-navigation-with-links__text"
            />
            <IconCustom icon="arrow" className="secondary-navigation-with-links__link-icon" />
          </ScrollLink>
        ))}
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FragmentSecondaryNavigationWithLinks on TSecondaryNavigationWithLinks {
    structure
    properties {
      items {
        properties {
          label
          link {
            url
            name
            target
            queryString
          }
        }
      }
    }
  }
`;

export default SecondaryNavigationWithLinks;
